$("#juy-logo").click(function() {
    $('html, body').animate({
        scrollTop: $(".section-2").offset().top
    }, 500);
});



// WEBPACK FOOTER //
// ./assets/js/features/scrollToElement.js